export default __webpack_public_path__ + "static/media/ScreenShot_1.d09c8792.jpg";